import type { ProductListResultViewModel } from 'autogen/swagger/all';
import styled from 'styled-components';
import { animated } from '@react-spring/web';
import LoadingContainer from 'components/checkout/components/BasketOverview/components/LoadingContainer';
import { useIsFetching } from '@tanstack/react-query';
import FilterMenuOpenerRenderer from './Filters/FilterMenuOpenerRenderer';

const StaticFilterContainer = styled<any>(animated.div)``;

export default function StaticFilterContent({
    model,
    ...restProps
}: { model: ProductListResultViewModel } & { [x: string]: any }) {
    const isLoading = useIsFetching({ queryKey: ['productListPartial'] });

    return (
        <LoadingContainer isLoading={!!isLoading}>
            <StaticFilterContainer {...restProps}>
                {/* Renders all filter menu openers */}
                <FilterMenuOpenerRenderer model={model} />
            </StaticFilterContainer>
        </LoadingContainer>
    );
}
